<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Documento</label>
                <div class="field-label field-label-center">{{ objView.subtipo }}</div>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">Protocolo</label>
                <div class="field-label">{{ objView.protocolo }}</div>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">Protocolo Referência</label>
                <div class="field-label">{{ objView.refprotocolo }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Identificação</label>
                <div class="field-label">{{ objView.refidentificacao }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Data Registro</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtregistro) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Homologação</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateTimeFromJson(objView.dhhomologacao) }}</div>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">Status</label>
                <div class="field-label">{{ objView.nmstatus }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item-char30">
                <label class="label-caption">Instituição</label>
                <div class="field-label field-label">{{ objView.nmep }}</div>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">Serviço de Inspeção</label>
                <div class="field-label">{{ objView.nmsim }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ objView.nmestabelecimento }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Informações</label>
                <textarea v-model="objView.informacoes" rows="5" maxlength="3000" readonly/>
            </div>
        </div>
        
        
        <div class="row-end">
            <button type="button" @click="visualizarLaudo">Laudo</button>
            <button type="button" @click="closeForm">Retornar</button>
        </div>
    </div>

    <div v-if="globalStore.ckperfilinspetor && objView.cdstatus === 3" class="form-edit-page">
        <CabecalhoFormGroup class="row-space" titulo="DOCUMENTO AGUARDANDO HOMOLOGAÇÃO" />

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="detalhamento">Justificativa</label>
                <textarea v-model="edJustificativa" id="detalhamento" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>

        <div class="row-end">
            <button class="btn-cancel" type="button" @click="confirmaHomologacao(false)">INDEFERIR</button>
            <button class="btn-confirm" type="button" @click="confirmaHomologacao(true)">HOMOLOGAR</button>
        </div>
    </div>

    <SenhaModal ref="senhaModalRef" />
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAssinatura } from '@/models/assinatura';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import CabecalhoFormGroup from '@/components/CabecalhoFormGroup.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});
const senhaModalRef = ref(null);

const edJustificativa = ref();
const isLoading = ref(false);
const msgAlerta = ref(null);
const objView = ref({});


function closeForm(){emit('close');}


async function confirmaHomologacao(ckAprovar){
    if (!ckAprovar){
        const r = Validar.texto(edJustificativa.value, 'Necessário informar justficativa');
        if (!r.ok){msgAlerta.value=r.msg; return;}
    }

    try{
        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;

        isLoading.value = true;

        // REGISTRAR ASSINATURA
        const objAssinatura = criarAssinatura();
        objAssinatura.idep            = globalStore.idep;
        objAssinatura.idusuario       = globalStore.idusuario;
        objAssinatura.idsessao        = globalStore.idlogin;
        objAssinatura.nmusuario       = globalStore.nmusuario;
        objAssinatura.vssistema       = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.ass_conteudo    = `REF:DOCANULACAO|IDREF:${objView.value.id}|PROT:${objView.value.protocolo}`;
        objAssinatura.ass_senha       = senhaDigitada;
        objAssinatura.ass_tipoauth    = 'senha pessoal via sistema WEB';
        objAssinatura.doc_idorigem    = objView.value.refid;
        objAssinatura.doc_tipo        = 'DOCANULACAO';
        const respAss = await Api.genericPut('/doc/assinar', objAssinatura);
        if (respAss.bolok != 1) throw new Error(`ATENÇÃO: ${respAss.erro}`);

        // GRAVAR DADOS DE HOMOLOGAÇÃO
        const respDoc = await Api.genericPut('/doc/docanulacao', {
            id: objView.value.id,
            idhomologacao: respAss.id,
            ckhomologacao: ckAprovar ? 'S' : 'N',
            jshomologacao: edJustificativa.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario
        });
        if (respDoc.bolok != 1) throw new Error(`ATENÇÃO: ${respDoc.erro}`);

        // EXECUTAR ROTINA DE HOMOLOGAÇÃO
        const respExec = await Api.genericPost('/doc/exec_requisicao', {
            id: respDoc.id,
            idep: globalStore.idep,
            nmrequisicao: 'SPDOCANULACAO_HOMOLOGAR',
            idusuario: globalStore.idusuario,
            idlogin: globalStore.idlogin});

        if (respExec.bolok==1){
            lerDados();
        }else{throw new Error(respExec.erro)}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


async function lerDados(){
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/lsdoc/docanulacao', {idep: globalStore.idep, id: props.idView});
        Object.assign(objView.value, req[0]);
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


async function visualizarLaudo(){
    try {
        if (!objView.value.idanexo) throw new Error('Laudo não disponível');
        msgAlerta.value = null;
        isLoading.value = true;        
        const response = await Api.genericAnexo(objView.value.idanexo);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}


onMounted(lerDados)
</script>